import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Alert } from '@mui/material';
import { useAuth } from '../auth/AuthContext';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { subscribeNetworkChanges } from '../mobile/networkService';
import { canDataUsage, DATA_USAGE_PERMISSION_REQUIRED, openDataUsageSettings, uploadDataUsageQueue } from '../services/dataUsageTelemetryService';
import { createDataUsageRecovery } from '../services/dataUsageRecovery';

export default function DataUsageLifecycle() {
    const { user } = useAuth();
    const [open, setOpen] = useState(false), [error, setError] = useState(null);
    const enabled = canDataUsage(user, 'registrar_propio');
    useEffect(() => {
        if (!enabled) return undefined;
        let disposed = false, unsubscribe, appListener;
        const recovery = createDataUsageRecovery({ upload: uploadDataUsageQueue });
        const recover = () => { if (!disposed) void recovery.recover(); };
        const permission = () => { setError(null); setOpen(true); };
        window.addEventListener(DATA_USAGE_PERMISSION_REQUIRED, permission);
        void subscribeNetworkChanges(connected => { if (connected) recover(); }).then(stop => { if (disposed) stop(); else unsubscribe = stop; }).catch(() => {});
        if (Capacitor.isNativePlatform()) void App.addListener('appStateChange', ({ isActive }) => { if (isActive) recover(); }).then(listener => { if (disposed) listener.remove(); else appListener = listener; });
        recover();
        return () => { disposed = true; recovery.dispose(); unsubscribe?.(); appListener?.remove(); window.removeEventListener(DATA_USAGE_PERMISSION_REQUIRED, permission); };
    }, [enabled, user?.id, user?.empresa_id]);
    return <Dialog open={open && enabled} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Acceso a datos de uso</DialogTitle>
        <DialogContent>
            <DialogContentText sx={{ whiteSpace: 'pre-line' }}>{'Para iniciar jornada en un equipo habilitado para técnicos se requiere este acceso.\n\nSe registran los totales mensuales de IFCI TEC, del equipo, de otras aplicaciones y de compartir Internet. Los gerentes autorizados de tu empresa pueden auditar estos datos. No se lee el contenido de las aplicaciones.\n\nActivá el acceso para IFCI TEC en los ajustes de Android y luego volvé a iniciar jornada.'}</DialogContentText>
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        </DialogContent>
        <DialogActions><Button onClick={() => setOpen(false)}>Volver</Button><Button variant="contained" onClick={async () => {
            try { await openDataUsageSettings(); setOpen(false); } catch (e) { setError(e.message); }
        }}>Abrir ajustes</Button></DialogActions>
    </Dialog>;
}
